<!--
 * @Author: 曹捷
 * @Date: 2020-04-22 14:28:39
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-07-05 15:50:13
 * @Description:  布局layout 
 -->
<template>
  <!-- router mate  fullPage  不使用布局  直接全屏 -->
  <div class="loadingFull" loading-spinner="pacman" v-if="!config.isQianKun" v-show="loadPermission" v-loading="loadPermission">
  </div>
  <!-- 1、单独启动子应用或者主框架，需要加载权限  -->
  <!-- 2、子应用集成到主框架 权限交给主框架统一控制 -->
  <template v-if="!loadPermission || config.isQianKun">
    <template v-if="routeMate.fullPage">
      <router-view></router-view>
    </template>
    <!-- 子应用 乾坤环境  ，调用layoutQiankun 布局 -->
    <component class="wui-main" :fullPage="fullPage" :class="config.theme.theme" :is="config.layout" v-else>
      <template v-slot:menu>
        <Sidebar class="" />
      </template>
      <template v-slot:header>
        <navbar />
      </template>
      <template v-slot:body>
        <!-- <div id="subapp-viewport" class="h100" v-show="!routeMate.mainApp"></div> -->
        <subAppMainVue></subAppMainVue>
        <!-- routeMate.mainApp 只在主应用的二级路由  目前只有home 首页-->
        <template v-if="routeMate.mainApp">
          <app-main />
        </template>
        <template v-else>
          <app-main v-show="config.subApp" />
        </template>
      </template>
      <template v-slot:foot>
      </template>
    </component>
  </template>
</template>

<script>
import Navbar from './components/Navbar.vue'
import layoutLeft from './layout/layoutLeft.vue'
import Sidebar from './components/sidebar.vue'
import AppMain from './components/AppMain.vue'
import { routerPermission } from "obit-wui/utils/validate.js";
import { inject, reactive, ref, computed, onMounted, watch, toRaw, toRefs, nextTick, onUnmounted } from 'vue';
import { useStore, mapGetters } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import themeServer from 'obit-wui/config/theme'
import register from 'obit-wui/qiankun/register'
import qkStore from 'obit-wui/qiankun/qkStore.js'
import subAppMainVue from './layout/compoents/subAppMain.vue'
import { userRole } from 'obit-wui/utils/auth'
import MenuHook from './hook/menu'
import { pushState } from './hook/history'

export default {
  name: "Layout",
  inheritAttrs: false,
  components: {
    Navbar,
    Sidebar,
    AppMain,
    layoutLeft, subAppMainVue
  },
  setup (props, context) {
    let http = inject('http')
    let store = useStore()
    let _data = reactive({
      loadPermission: true,
      fullPage: false
    })
    let route = useRoute()
    let router = useRouter()

    let config = store.state.settings
    let _computed = {
      config: computed(() => config),
      routeMate: computed(() => route.meta)
    }
    let methods = {
      listenerFullPage (fullpage) {
        _data.fullPage = fullpage
      }
    }
    let _methods = {
      handleClickOutside () {
        store.dispatch("app/closeSideBar", { withoutAnimation: false });
      },
      init () {
        let rs = JSON.parse(localStorage.getItem('rs'))
        document.title = `${config.title}${config.navbarTitle}`
        // 默认初始化  css主题
        nextTick(() => {
          // themeServer.addTheme('industrial', themeInfo)
          themeServer.changeCssTheme(config.theme.theme)
        })
        if (rs.permission && !route.meta.fullPage) {
          this.initMenu()
        } else {
          _data.loadPermission = false;
        }
      },
      initMenu () {
        let info = {
          http,
          // subApp  子应用，传入对应appCode 只查询对应应用菜单
          // 主应用 不传appCode 查询所有系统菜单
          data: { appCodeList: config.subApp ? [config.auth.appCode] : [] }
        }
        store.dispatch("permission/getUserPermission", info).then((res) => {
          if (!routerPermission(store.state.permission.sysMenu, route.path, route.meta)) {
            router.push({ path: "/401" });
            return
          }
          _methods.beforeMounted();
          _data.loadPermission = false;

          nextTick(() => {
            register(http, store.state.permission.menuList, store.state.permission.sysBtn, () => {
              let user = userRole.get()
              if (!user.tenantSuperUser) {
                /** 修复
                 * 非管理员刷新的时候总是去第一个服务
                 * 只有进来的页面非子服务的页面才跳第一个服务
                 */
                if (store.state.permission.sysMenu.findIndex(el => route.path.indexOf(el.path) !== -1) === -1) {
                  MenuHook().toCenterController(store)
                }
              }
              qkStore.addListener('fullPage', methods.listenerFullPage)
            }, { goto: pushState })
          })
        }).catch(() => {
          _data.loadPermission = false;
        })
      },
      // 钩子函数  应用加载之前
      async beforeMounted () {
        if (config.beforeMounted && config.beforeMounted instanceof Function) {
          await config.beforeMounted({ http, store });
        }
      },
      async initUploadSDK () {
        let data = await http.sysPost('system/config/getFileConfigMode')
        let ase = new Ase({ tokenKey: store.state.settings.TokenKey })
        let uploadConfig = ase.aesDecode(data)
        uploadConfig = JSON.parse(uploadConfig)
        if (uploadConfig.mode === 'MINIO') {
          // 引入Minio 上传SDK
          app.config.globalProperties.uploadSDK = new MinioSDK(Object.assign({ bucketName: 'saas', http, appName: 'CENTER' }, uploadConfig))
        } else if (uploadConfig.mode === 'QINIU') {
          // 引入七牛云SDK
          app.config.globalProperties.uploadSDK = new UploadSDK(uploadConfig.bucketName, http, 'IOT', store.state.settings.TokenKey)
        }
      }

    }
    onMounted(() => {
      // 初始化store  user  token
      store.commit('user/init')
      if (!config.isQianKun) {
        _methods.init()
      }
    })
    // 监听 只有从登录页面 跳转进来 需要重新请求初始化信息
    watch(() => route.path, (path, oldPath) => {
      if (/\/login\b/.test(oldPath)) {
        if (!config.isQianKun) {
          _methods.init()
        }
      }
    })

    onUnmounted(() => {
      qkStore.removeListener('fullPage', methods.listenerFullPage)
    })
    return {
      ...toRefs(_data), ..._computed, ..._methods
    }
  },
};
</script>

<style lang="less" scoped>
// @import '~@/common-modules/styles/variables.less';
.loadingFull {
  width: 100%;
  height: 100%;
}
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  // width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
#subapp-viewport {
  > :first-child {
    height: 100%;
  }
}
</style>
